var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 0.833984C4.93717 0.833984 0.833252 4.9379 0.833252 10.0007C0.833252 15.0634 4.93717 19.1673 9.99992 19.1673C15.0627 19.1673 19.1666 15.0634 19.1666 10.0007C19.1666 4.9379 15.0627 0.833984 9.99992 0.833984ZM13.0185 14.3154L9.08325 10.3802V4.50065H10.9166V9.62115L14.3147 13.0192L13.0185 14.3154Z",
    fill: "#40506A",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduled);
export default __webpack_public_path__ + "static/media/Scheduled.2bf503adf0229dafd8dee1b66d6f60b3.svg";
export { ForwardRef as ReactComponent };